var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDuration2Selected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b6b6;}.cls-2{fill:#dcdcdc;}.cls-3{fill:#f1f1f1;}.cls-4{fill:#333;}.cls-5{fill:#ec6841;}.cls-6{fill:#fff;}.cls-7{fill:#af975c;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "duree2_selected",
    "data-name": "duree2 selected"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41,31A13.47,13.47,0,1,1,27.53,17.51,13.47,13.47,0,0,1,41,31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.16,20.43a13.18,13.18,0,0,0-1.71,1.63l-1-1,1.67-1.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.48,
    y: 18.65,
    width: 4.4,
    height: 1.78,
    transform: "translate(-8.93 17.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.6,21.05l-1,1a13.9,13.9,0,0,0-1.72-1.63l1-1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.46,
    y: 17.34,
    width: 1.78,
    height: 4.4,
    transform: "translate(-2.58 32.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.86,31a2.81,2.81,0,0,1,0,.29,9.89,9.89,0,0,1-.67,3.4c-.06.18-.14.35-.22.53A10,10,0,0,1,35,38.08c-.13.14-.26.27-.4.4a10,10,0,0,1-2.89,1.93,3.38,3.38,0,0,1-.52.22,9.9,9.9,0,0,1-3.41.67,1.27,1.27,0,0,1-.28,0,1.32,1.32,0,0,1-.28,0,9.9,9.9,0,0,1-3.41-.67l-.53-.22a10,10,0,0,1-2.88-1.93c-.14-.13-.27-.26-.4-.4A10,10,0,0,1,18.1,35.2a4,4,0,0,1-.22-.53,9.89,9.89,0,0,1-.67-3.4,1.42,1.42,0,0,1,0-.29,1.37,1.37,0,0,1,0-.28,10.13,10.13,0,0,1,.66-3.41c.07-.17.14-.35.22-.52A10.33,10.33,0,0,1,20,23.88c.13-.14.26-.27.4-.4a10,10,0,0,1,2.88-1.93l.53-.22a9.9,9.9,0,0,1,3.41-.67h.56a9.9,9.9,0,0,1,3.41.67,4.77,4.77,0,0,1,.52.22,10,10,0,0,1,2.89,1.93c.14.13.27.26.4.4A10.33,10.33,0,0,1,37,26.77l.22.52a10.13,10.13,0,0,1,.66,3.41,2.72,2.72,0,0,1,0,.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.33,16v1.72a14.41,14.41,0,0,1,2.2-.18,14.64,14.64,0,0,1,2.21.18V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.86,31a2.72,2.72,0,0,0,0-.28,10.13,10.13,0,0,0-.66-3.41L37,26.77A10.33,10.33,0,0,0,35,23.88c-.13-.14-.26-.27-.4-.4a10,10,0,0,0-2.89-1.93,4.77,4.77,0,0,0-.52-.22,9.9,9.9,0,0,0-3.41-.67h-.56L27.53,31H37.86c0,.1-10.33,0-10.33,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.35,16H24.71a3,3,0,1,1,0-6h5.64a3,3,0,1,1,0,6m-5.64-4.39a1.42,1.42,0,1,0,0,2.83h5.64a1.42,1.42,0,1,0,0-2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M30,37.1a6.6,6.6,0,1,1,3.64-8.6A6.61,6.61,0,0,1,30,37.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.12,21.88l.53,1.3-.5.2-.52-1.3.24-.11.25-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.91,38.59l.52,1.29-.24.11-.25.09-.53-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.88,24.87l-.38.38-1-1c.12-.13.24-.26.37-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.54,37.71a3.41,3.41,0,0,1-.38.38l-1-1,.38-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20,27.5l-.21.49-1.28-.55a4.1,4.1,0,0,1,.21-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.58,34.52c-.06.17-.13.33-.2.49l-1.29-.55L35.3,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.22,30.66v.53h-1.4a4.69,4.69,0,0,1,0-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.25,30.78a3.25,3.25,0,0,1,0,.54h-1.4v-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.72,33.86l.2.5-1.29.52a2.56,2.56,0,0,1-.11-.24,1.84,1.84,0,0,1-.09-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.54,27.33a1.06,1.06,0,0,1,.09.25l-1.29.52-.2-.49,1.29-.53a1.12,1.12,0,0,1,.11.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.8,37l-1,1a4.44,4.44,0,0,1-.38-.37l1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.64,24.35l-1,1L33.27,25l1-1c.13.12.25.25.37.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.54,38.75,24,40a4.1,4.1,0,0,1-.48-.21L24,38.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.55,22.14,31,23.42l-.49-.2.55-1.29a4.1,4.1,0,0,1,.48.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.74,39.3v1.4h-.54v-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.87,21.27v1.4h-.53v-1.4a3.25,3.25,0,0,1,.54,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29,30.27l4.44.91L29,31.87a1.64,1.64,0,1,1-1.37-2.48,1.62,1.62,0,0,1,1.41.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27.53,31.89A.86.86,0,1,0,26.7,31a.85.85,0,0,0,.83.88"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 55,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuration2Selected);
export default __webpack_public_path__ + "static/media/icon_duration_2_selected.eaf08caeb71c7a86726c931cdff601ec.svg";
export { ForwardRef as ReactComponent };